import React from 'react';
import styled from 'styled-components';
import { FaRedo, FaQuestion, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

const GameControls = ({ onNewGame, onHelp, isSoundOn, onToggleSound }) => {
  return (
    <ControlsContainer>
      <ControlButton onClick={onNewGame} title="새 게임">
        <FaRedo />
      </ControlButton>
      <ControlButton onClick={onHelp} title="도움말">
        <FaQuestion />
      </ControlButton>
      <ControlButton onClick={onToggleSound} title={isSoundOn ? "소리 끄기" : "소리 켜기"}>
        {isSoundOn ? <FaVolumeUp /> : <FaVolumeMute />}
      </ControlButton>
    </ControlsContainer>
  );
};

const ControlsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 10px;
  background-color: #143d28;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;

const ControlButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8cb66;
  color: #1a4d2e;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5b945;
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export default GameControls;
